// extracted by mini-css-extract-plugin
export var box = "Modal-module--box--c1f61";
export var box_md = "Modal-module--box_md--3f9bf";
export var box_xmd = "Modal-module--box_xmd--e1092";
export var box_flex = "Modal-module--box_flex--74178";
export var box_lg = "Modal-module--box_lg--3b656";
export var box_sm = "Modal-module--box_sm--7d7f0";
export var box_outer = "Modal-module--box_outer--3eeac";
export var box_whiteBg = "Modal-module--box_white-bg--873c0";
export var box_noMarginBottom = "Modal-module--box_no-margin-bottom--500cf";
export var box_noPadding = "Modal-module--box_no-padding--1011d";
export var box_outerGray = "Modal-module--box_outer-gray--29236";
export var box_dark = "Modal-module--box_dark--2c5c9";
export var box_zIndex = "Modal-module--box_z-index--f0422";
export var box_zIndex6 = "Modal-module--box_z-index-6--a3b5b";
export var box_eventsWithLine = "Modal-module--box_events-with-line--f0f0a";
export var box_featuresAo = "Modal-module--box_features-ao--b20b3";
export var box_verticalPaddings = "Modal-module--box_vertical-paddings--7fa94";
export var clearP = "Modal-module--clearP--20971";
export var clearP_vc = "Modal-module--clearP_vc--78228";
export var popup = "Modal-module--popup--62543";
export var disable = "Modal-module--disable--522f1";
export var request = "Modal-module--request--bdaaf";
export var content = "Modal-module--content--7a02f";
export var send = "Modal-module--send--ec307";
export var sendRacing = "Modal-module--sendRacing--c9603";
export var container = "Modal-module--container--1ae9b";
export var consentModalRacing = "Modal-module--consentModalRacing--bf499";
export var traineeInvitationSend = "Modal-module--traineeInvitationSend--06459";
export var sendKazakhstan = "Modal-module--sendKazakhstan--55ad4";
export var sendOwlSoul = "Modal-module--sendOwlSoul--e81d0";
export var galleryOwlSoul = "Modal-module--galleryOwlSoul--d525a";
export var galleryOwlSoulVertical = "Modal-module--galleryOwlSoulVertical--4a030";
export var fullWidthMobile = "Modal-module--fullWidthMobile--3e990";
export var alignDisable = "Modal-module--alignDisable--1194c";
export var tooHigh = "Modal-module--tooHigh--6f4ae";
export var tooHighGallery = "Modal-module--tooHighGallery--74eaf";
export var services = "Modal-module--services--610b2";
export var calculator = "Modal-module--calculator--fcfea";
export var player = "Modal-module--player--4c473";
export var large = "Modal-module--large--68565";
export var xlarge = "Modal-module--xlarge--b7628";
export var medium = "Modal-module--medium--473d1";
export var small = "Modal-module--small--ad910";
export var xs = "Modal-module--xs--5f346";
export var wide = "Modal-module--wide--929b3";
export var withAside = "Modal-module--withAside--25066";
export var fullScreenMobile = "Modal-module--fullScreenMobile--4876a";
export var consentModal = "Modal-module--consentModal--b00bb";
export var alumniRegistrationModal = "Modal-module--alumniRegistrationModal--3480c";
export var loading = "Modal-module--loading--bcff5";
export var opacity = "Modal-module--opacity--970d9";
export var transparent = "Modal-module--transparent--145d2";
export var active = "Modal-module--active--480ba";
export var show = "Modal-module--show--e8a34";
export var bottomToTop = "Modal-module--bottomToTop--4bde8";
export var topToBottom = "Modal-module--topToBottom--c608b";
export var left = "Modal-module--left--c1a63";
export var rightToLeft = "Modal-module--rightToLeft--717e8";
export var leftToRight = "Modal-module--leftToRight--a27f7";
export var paddingXL = "Modal-module--paddingXL--0d421";
export var paddingMD = "Modal-module--paddingMD--e810e";
export var workflow = "Modal-module--workflow--4f656";
export var indent = "Modal-module--indent--53d45";
export var withoutMargin = "Modal-module--withoutMargin--895d8";
export var withoutMarginMobile = "Modal-module--withoutMarginMobile--7c47f";
export var rounded = "Modal-module--rounded--d7373";
export var consentModalRounded = "Modal-module--consentModalRounded--88f4d";
export var virtualTour = "Modal-module--virtualTour--1b43e";
export var concept = "Modal-module--concept--bc702";
export var gallery = "Modal-module--gallery--bac97";
export var photoGallery = "Modal-module--photoGallery--5c2a7";
export var closeButton = "Modal-module--closeButton--70da6";
export var fadeInAnimation = "Modal-module--fadeInAnimation--0679d";
export var placeHolderShimmer = "Modal-module--placeHolderShimmer--70946";